export default {
    NAME: 'Kaetram',
    DESCRIPTION:
        'Kaetram ay isang open-source na game-engine, nilikha ito para tulungan and mga interesadong pumasok sa larangan na pag develop ng laro. Ang original na ideya ay batay sa larong BrowserQuest. Ang mga assets ay pareho ngunit and code ay binura at muling ginawa sa simula'
} as const;
